import { useState } from "react";

export function DeclineDialog({ playerName, busy, onCancel, onConfirm }: {
    playerName: string; busy: boolean; onCancel: () => void; onConfirm: (message: string) => void;
}) {
    const [message, setMessage] = useState("");
    return (
        <div className="modal-backdrop" onClick={busy ? undefined : onCancel}>
            <div className="modal" role="dialog" aria-modal="true" aria-labelledby="decline-title" onClick={(e) => e.stopPropagation()}>
                <h2 id="decline-title">Decline {playerName}&rsquo;s clip?</h2>
                <p className="muted">They will be told you could not take this one and can send it to another coach. You can add a short reason.</p>
                <textarea value={message} maxLength={500} rows={3} placeholder="Optional message to the player"
                    onChange={(e) => setMessage(e.target.value)} />
                <div className="modal-actions">
                    <button className="btn" onClick={onCancel} disabled={busy}>Keep it</button>
                    <button className="btn danger" onClick={() => onConfirm(message.trim())} disabled={busy}>{busy ? "Declining" : "Decline"}</button>
                </div>
            </div>
        </div>
    );
}
